export default "__VITE_ASSET__nlaKKG65__"